type BootstrapData = {
	geo?: { country?: string };
};

export function getGeoCountry(): string {
	const data = (window as unknown as { __BOOTSTRAP_DATA__?: BootstrapData })
		.__BOOTSTRAP_DATA__;
	return data?.geo?.country ?? "XX";
}
